import type * as React from 'react';
import { cn } from '@/lib/utils/index';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 py-10 px-6 text-center',
        className,
      )}
    >
      {icon && (
        <div className='flex items-center justify-center w-12 h-12 rounded-full bg-muted text-muted-foreground'>
          {icon}
        </div>
      )}
      <div className='flex flex-col gap-1'>
        <p className='text-sm font-medium text-foreground'>{title}</p>
        {description && (
          <p className='text-xs text-muted-foreground max-w-xs'>
            {description}
          </p>
        )}
      </div>
      {action && <div className='mt-1 pointer-events-auto'>{action}</div>}
    </div>
  );
}
